<template>
  <div class="input-switch">
    <input
      :id="id"
      type="checkbox"
      v-bind="$attrs"
      v-on="$listeners" />
    <label :for="id">
      <div class="switch">
        <div class="inner"></div>
      </div>
      <span class="label">{{label}}</span>
    </label>
  </div>
</template>

<style lang="scss" scoped>

.input-switch {
  display: flex;
  align-items: center;
}

input {
  display: none;
}

label {
  width: auto;
}

.label {
  margin-left: $spacing--xxs;
  cursor: pointer;
}

.switch {
  width: $spacing--l;
  height: $spacing--s;
  border-radius: 2.5rem;
  border: 2px solid var(--color--secondary);
  display: flex;
  align-items: center;
  padding: 4px;
  transition: 240ms ease-out;
  .inner {
    width: $spacing--xs;
    height: $spacing--xs;
    background-color: var(--color--secondary);
    border-radius: 2rem;
    transition: 240ms ease-out;
  }
}

input:checked ~ label .switch {
  border-color: var(--color--action);
  background-color: var(--color--action);
  .inner {
    background-color: var(--color--white);
    transform: translateX(1.4rem);
  }
}

</style>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default () {
        return uuid()
      }
    },
    group: {
      type: String
    },
    label: {
      type: String
    }
  }
}
</script>
